@if (content) {
<div class="bg-col-56 flex flex-justify-center flex-middle">
    <div class="p2 center col-w m-a m-a-2-m m-a-2-s">
        <i class="_icon icon-delivery"></i>&nbsp;
        <span *iCms="'text' of content; content: 'html'"></span>
        <a class="underline"
           *iCms="'linkText' of content; content: 'html'"
           [routerLink]="content.url"></a>
    </div>
</div>
}
